import { BreakpointsMinQuery } from '@ab-core/breakpoints';
import { Col } from '@ab-core/grid';
import styled from 'styled-components';

export const SubmitCol = styled(Col)`
    display: flex;
    justify-content: flex-start;
    padding-bottom: 20px;
    @media ${BreakpointsMinQuery.sm} {
        padding-bottom: 0;
        justify-content: flex-end;
    }
`;
